import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: (hasProjectNotificationsEnabled: boolean | null | undefined, workspaceName: string | undefined) => string;
    error: (hasProjectNotificationsEnabled: boolean | null | undefined) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Toast message shown after toggling workspace notifications */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (hasProjectNotificationsEnabled: boolean | null | undefined, workspaceName: string | undefined): string => { const projectNotificationsEnabled = !!hasProjectNotificationsEnabled; return __intl__.intl().formatMessage({ id: "useToggleWorkspaceNotifications.title.0?c=26cm5ky6ucvmw", defaultMessage: "{projectNotificationsEnabled, select, true {Notifications disabled for all projects in \"{workspaceName}\".} other {Notifications enabled for all projects in \"{workspaceName}\".}}" }, { projectNotificationsEnabled: projectNotificationsEnabled, workspaceName: workspaceName }); });
                },
                enumerable: true,
                configurable: true
            },
            /** Error message when toggling workspace notifications fails */
            error: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (hasProjectNotificationsEnabled: boolean | null | undefined): string => { const projectNotificationsEnabled = !!hasProjectNotificationsEnabled; return __intl__.intl().formatMessage({ id: "useToggleWorkspaceNotifications.error.0?c=1n8c73ijyg5lu", defaultMessage: "{projectNotificationsEnabled, select, true {Notifications can''t be disabled at this time.} other {Notifications can''t be enabled at this time.}}" }, { projectNotificationsEnabled: projectNotificationsEnabled }); });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
